import AxiosInstance from "./AxiosInstance";

// Get All Admin Users
export const getAllAdminUsers = async () => {
  try {
    const { data } = await AxiosInstance.get("/admin_user");
    return data;
  } catch (error) {
    console.log(error);
    throw error;
  }
};
